import { ComponentProps, FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { BaseModal } from '../BaseModal';
import { ModalPattern } from '../common';
import { SuccessModalFooter } from './SuccessModalFooter';
import { SuccessModalIcon } from './SuccessModalIcon';

type SuccessModalProps = ComponentProps<typeof BaseModal> & Omit<ComponentProps<typeof SuccessModalFooter>, 'onCancel'>;

export const SuccessModal: FC<SuccessModalProps> = ({ children, classNames, isDismissable, onClose, ...footerProps }) => {
  return (
    <BaseModal
      onClose={onClose}
      classNames={{
        content: twMerge('max-w-[22rem] min-h-64', classNames?.content),
        ...classNames,
      }}
      isDismissable={isDismissable}
    >
      <ModalPattern />
      <div className='flex flex-col gap-4'>
        <SuccessModalIcon />
        {children}
      </div>
      <SuccessModalFooter {...footerProps} />
    </BaseModal>
  );
};
